var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cd-section",attrs:{"id":"testimonials"}},[_c('Testimonial1'),_c('Testimonial2'),_c('Testimonial3')],1)}
var staticRenderFns = []

export { render, staticRenderFns }